import React, { useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useResizeDetector } from 'react-resize-detector';
import Box from '@mui/material/Box';

import useDebounce from 'hooks/useDebounce';

const SummaryChart = ({
                        data = [],
                        height,
                        xAxis = '',
                        yAxis = '',
                        handleClick = () => {
                        },
                        xMax = 0,
                        yMax = 0,
                      }) => {

  const charOptions = () => {
    return {
      chart: {
        renderTo: 'container',
        spacingLeft: 0,
        spacingRight: 120,
        spacingTop: 40,
        plotBackgroundColor: '#fff',
        height,
        events: {
          load() {
            const chart = this;

            const yValue = chart.yAxis[0];
            const xValue = chart.xAxis[0];
            const top = yValue.top;
            const left = yValue.left;
            const yZero = yValue.toPixels(0);
            let xZero = xValue.toPixels(0);
            const yHeight = yValue.height;
            const xWidth = yValue.width;
            if (xZero < 0) {
              xZero = left;
            }

            chart.topLeft = chart.renderer.text(`Program impact works for improving ${yAxis} but not for improving ${xAxis}`, left, top)
              .css({
                fontSize: '0.875rem',
                textAlign: 'center',
                fontWeight: 700,
                pointerEvents: 'none',
              })
              .add();

            chart.yLable = chart.renderer.text(`Impact on ${yAxis}`, xZero - 70, 16)
              .css({
                fontWeight: 'bold',
                padding: '4px 8px',
                fontSize: '0.875rem',
                textAlign: 'center',
                pointerEvents: 'none',
              })
              .add();

            chart.topRight = chart.renderer.text(`Programs are effective`, xZero, top)
              .css({
                fontSize: '0.875rem',
                textAlign: 'center',
                fontWeight: 700,
                pointerEvents: 'none',
              })
              .add();

            chart.bottomLeft = chart.renderer.text(`Programs are not effective`, left, yHeight + top)
              .css({
                fontSize: '0.875rem',
                textAlign: 'center',
                fontWeight: 700,
                pointerEvents: 'none',
              })
              .add();

            chart.bottomRight = chart.renderer.text(`Program impact works for improving ${xAxis} but not for improving ${yAxis}`, xZero, yHeight + top)
              .css({
                fontSize: '0.875rem',
                textAlign: 'center',
                fontWeight: 700,
                pointerEvents: 'none',
              })
              .add();

            chart.xLable = chart.renderer.text(`Impact on ${xAxis}`, xWidth, yZero)
              .css({
                fontWeight: 'bold',
                padding: '4px 8px',
                fontSize: '0.875rem',
                textAlign: 'center',
                pointerEvents: 'none',
              })
              .add();
          },
          render() {
            const chart = this;

            const yValue = chart.yAxis[0];
            const xValue = chart.xAxis[0];
            const top = yValue.top;
            const left = yValue.left;
            const yZero = yValue.toPixels(0);
            let xZero = xValue.toPixels(0);
            const yHeight = yValue.height;
            const xWidth = yValue.width;

            if (xZero < 0) {
              xZero = left;
            }
            chart.topLeft.destroy();
            chart.topLeft = chart.renderer
              .text(
                `<span style="color: #3b91e4;">⬆️ ${yAxis}</span> impact<br><span style="color: #FF00FF;">⬇️ ${xAxis}</span> impact`,
                0,
                top +20,
                true
              )
              .css({
                fontSize: '0.875rem',
                textAlign: 'left',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                color: '#636363',
                width: `${xZero - left}px`,
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              })
              .add();

            chart.yLable.destroy();
            chart.yLable = chart.renderer.text(`Impact on ${yAxis}`, xZero - 70, 24, true)
              .css({
                fontWeight: 'bold',
                padding: '4px 8px',
                fontSize: '0.875rem',
                textAlign: 'center',
                paddingBottom: '1.5em',
                pointerEvents: 'none',
              })
              .add();

            chart.topRight.destroy();
            chart.topRight = chart.renderer
              .text(
                `<span style="color: #3b91e4;">⬆️ ${yAxis}</span> impact<br><span style="color: #3b91e4;">⬆️ ${xAxis}</span> impact`,
                xZero+10,
                top + 20,
                true
              )
              .css({
                fontSize: '0.875rem',
                textAlign: 'left',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                color: '#636363',
                width: `${xWidth - xZero}px`,
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                pointerEvents: 'none'
              })
              .add();
            chart.bottomLeft.destroy();
            chart.bottomLeft = chart.renderer
              .text(
                `<span style="color: #FF00FF;">⬇️ ${yAxis}</span> impact<br><span style="color: #FF00FF;">⬇️ ${xAxis}</span> impact`,
                0,
                yHeight + 28,
                true
              )
              .css({
                fontSize: '0.875rem',
                textAlign: 'left',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                color: '#636363',
                width: `${xZero - left}px`,
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                pointerEvents: 'none'
              })
              .add();

            chart.bottomRight.destroy();
            chart.bottomRight = chart.renderer
              .text(
                `<span style="color: #FF00FF;">⬇️ ${yAxis}</span> impact<br><span style="color: #3b91e4;">⬆️ ${xAxis}</span> impact`,
                xZero+10,
                yHeight + 28,
                true
              )
              .css({
                fontSize: '0.875rem',
                textAlign: 'left',
                fontWeight: 700,
                whiteSpace: 'nowrap',
                color: '#636363',
                width: `${xWidth - xZero}px`,
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                pointerEvents: 'none'
              })
              .add();

            chart.xLable.destroy();
            chart.xLable = chart.renderer.text(`Impact on ${xAxis}`, xWidth-(xWidth/21), yZero-4, true)
              .css({
                fontWeight: 'bold',
                padding: '4px 8px',
                fontSize: '0.875rem',
                textAlign: 'center',
                whiteSpace: 'wrap',
                pointerEvents: 'none',
              })
              .add();
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: null,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        headerFormat: '',
        useHTML: true,
        backgroundColor: '#ffffff',
        borderColor: '#e5e5e5',
        outside: true,
        formatter: function() {
          return `<span style="font-size: 0.875rem; width:100%; line-height: 16px; font-family: Helvetica,Arial,serif;">
                                    <table>
                                    <tbody>
                                    <tr>
                      <td style="font-weight: 600">Program</td>
                      <td>${this.point.program}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600">Segment</td>
                      <td>${this.point.type}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600">Population</td>
                      <td>${this.point.population}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; border-top: 1px solid #ddd; padding-top: 8px;" colspan="2">${xAxis}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">Effect Size</td>
                      <td>${this.point.x.toFixed(3)}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">P-Value</td>
                      <td>${this.point.x_axis_p_value !== undefined ? this.point.x_axis_p_value.toFixed(4) : 'N/A'}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">Confidence Interval</td>
                      <td>${this.point.x_axis_effect_size_lcb !== undefined && this.point.x_axis_effect_size_ucb !== undefined ?
            `[${this.point.x_axis_effect_size_lcb.toFixed(3)} , ${this.point.x_axis_effect_size_ucb.toFixed(3)}]` : 'N/A'}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; border-top: 1px solid #ddd; padding-top: 8px;" colspan="2">${yAxis}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">Effect Size</td>
                      <td>${this.point.y.toFixed(3)}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">P-Value</td>
                      <td>${this.point.y_axis_p_value !== undefined ? this.point.y_axis_p_value.toFixed(4) : 'N/A'}</td>
                  </tr>
                  <tr>
                      <td style="font-weight: 600; padding-left: 16px;">Confidence Interval</td>
                      <td>${this.point.y_axis_effect_size_lcb !== undefined && this.point.y_axis_effect_size_ucb !== undefined ?
            `[${this.point.y_axis_effect_size_lcb.toFixed(3)} , ${this.point.y_axis_effect_size_ucb.toFixed(3)}]` : 'N/A'}</td>
                  </tr>
                  </tbody>
                  </table>
                  </span>`
        },
      },
      plotOptions: {
        series: {
          marker: {
            radius: 7.5,
            symbol: 'circle',
          },
          states: {
            inactive: {
              enabled: true,
              opacity: 0.1,
            },
          },
          point: {
            events: {
              click: function() {
                handleClick(this.type, this.standard_program);
              },
            },
          },
        },
      },
      xAxis: {
        title: {
          text: `Impact on ${xAxis}`,
          style: { fontSize: 'rem' },
          enabled: false,
        },
        tickAmount: 0,
        gridLineWidth: 0,
        showLastLabel: false,
        showFirstLabel: false,
        labels: {
          enabled: false,
        },
        lineColor: 'transparent',
        max:xMax,
        min:-xMax,
        width: '95%',
        right: '5%',
      },
      yAxis: {
        title: {
          text: `Impact on ${yAxis}`,
          style: { fontSize: '1rem' },
          enabled: false,
        },
        softMin: 0,
        tickAmount: 5,
        gridLineWidth: 0,
        labels: {
          enabled: false,
        },
        max:yMax,
        min:-yMax
      },
      annotations: [{
        shapes: [
          {
            type: 'path',
            fill: '#979797',
            points: [{
              x: 0,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }, {
              x: 0,
              y: yMax,
              xAxis: 0,
              yAxis: 32,
            }],
            markerEnd: 'arrow',
          },
          {
            type: 'path',
            fill: '#979797',
            points: [{
              x: 0,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }, {
              x: xMax,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }],
            markerEnd: 'arrow',
          },
          {
            type: 'path',
            fill: '#979797',
            points: [{
              x: 0,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }, {
              x: 0,
              y: -yMax,
              xAxis: 0,
              yAxis: 0,
            }],
            markerEnd: 'arrow',
          },
          {
            type: 'path',
            fill: '#979797',
            points: [{
              x: 0,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }, {
              x: -xMax,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }],
            markerEnd: 'arrow',
          },
        ],
        zIndex:1,
        draggable:''
      }],
    };
  };

  const colors = ['#0794d3', '#c50082', '#49ac43', '#df812e', '#3401af', '#cdae00', '#ff0000'];

  const [options, setOptions] = useState(charOptions());
  const [activeProgram, setActiveProgram] = useState(null);
  const chartRef = useRef(null);
  const { width, ref } = useResizeDetector();
  const chartWidth = useDebounce(width, 200);

  useEffect(() => {
    const series = [];

    data.forEach(function(group, index) {
      const flattened = group.data.reduce((subGroup, item) => {
        const program = item.program;
        const existing = subGroup.find(s => s.id === program);

        const pointData = {
          x: item.x,
          y: item.y,
          z: item.z,
          type: item.type,
          program: item.program,
          population: item.population,
          standard_program: item.standard_program,
          x_axis_p_value: item.x_axis_p_value,
          y_axis_p_value: item.y_axis_p_value,
          x_axis_effect_size_ucb: item.x_axis_effect_size_ucb,
          y_axis_effect_size_ucb: item.y_axis_effect_size_ucb,
          x_axis_effect_size_lcb: item.x_axis_effect_size_lcb,
          y_axis_effect_size_lcb: item.y_axis_effect_size_lcb,
        };

        if (existing) {
          existing.data.push(pointData);
        } else {
          subGroup.push({
            data: [pointData],
            name: program,
            id: program,
          });
        }

        return subGroup;
      }, []);

      const seriesList = [{
        name: group.name,
        color: colors[index],
        id: group.id,
        data: [],
      }];

      flattened.forEach(subGroup => {
        seriesList.push({
          linkedTo: group.id,
          id: subGroup.id,
          type: 'scatter',
          data: subGroup.data,
          name: subGroup.name,
          color: colors[index],
          stickyTracking: false,
          opacity: !activeProgram || activeProgram === subGroup.id ? 1 : 0.2,
          point: {
            events: {
              click: function () {
                if (activeProgram === this.program) {
                  setActiveProgram(null);
                } else {
                  setActiveProgram(this.program);
                }
              }
            }
          }
        });
      });

      series.push(...seriesList);
    });

    setOptions({
      ...charOptions(),
      series: series,
    });
  }, [data,xMax,yMax, activeProgram]);

  useEffect(() => {
    if (chartRef) {
      chartRef.current.chart.reflow();
    }
  }, [chartWidth,height]);

  return (<Box ref={ref}>
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default SummaryChart;
